/*
  RootApp.jsx
*/

// Npm.
import React from 'react';

// Components.
import ErrorBoundary from '../ErrorBoundary';
import ThemeProvider from './ThemeProvider';
import BotechProvider from './BotechProvider';
import RootWrapper from './RootWrapper';
import GraphPage from '../GraphPage';
import Footer from './Footer';

// Hooks.
import useGraphData from './useGraphData';
import useGraphSettings from './useGraphSettings';

/**
 * Renders the root app.
 */
function RootApp({ className, style, theme }) {

  // TODO: Wrap main app in a loader and keep "graphData" on the outermost layer?
  // Will minimize risk of graphData getting lost if we aren't using localStorage.

  const [graphData, setGraphData, graphDataHistory] = useGraphData();
  const [graphSettings, setGraphSettings] = useGraphSettings(theme);

  // Debug.
  const ENABLE_DEBUG = true;
  if (ENABLE_DEBUG) {
    window.__botech_graph_data = graphData;
    window.__botech_graph_settings = graphSettings;
    window.__botech_toggle_theme = () => setGraphSettings(obj => ({ ...obj, isDark: !obj.isDark }));
  }

  return (
    <ErrorBoundary fullScreen>
      <ThemeProvider isDark={graphSettings.isDark}>
        <RootWrapper className={className} style={style}>

          <GraphPage
            disableThemeToggle={Boolean(theme)}
            graphData={graphData}
            graphSettings={graphSettings}
            graphDataHistory={graphDataHistory}
            onChangeGraphData={setGraphData}
            onChangeGraphSettings={setGraphSettings}
          />

          <Footer />

        </RootWrapper>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

/**
 * Renders the root app, wrapped in the Botech context.
 */
export default function RootAppOuter({ botech, ...rest }) {
  return (
    <BotechProvider botech={botech}>
      <RootApp {...rest} />
    </BotechProvider>
  );
}
